// i think you should move it to the model ? check it up with meriem
export interface EditingTextState {
  pickparamsURL: boolean;
  showParameter: boolean;
  pickparamsprofile: boolean;
  orderpickparamsprofile: boolean;
  showem: boolean;
  showLength: boolean;
  showPersonolization: boolean;
  textLen: number;
  textMaxLen: number;
}

export const initialEditingTextState: EditingTextState = {
  pickparamsURL: false,
  showParameter: false,
  pickparamsprofile: false,
  orderpickparamsprofile: false,
  showem: false,
  showLength: false,
  showPersonolization: false,
  textLen: 0,
  textMaxLen: 80,
};